import React from 'react';
import { Icon } from './Icon.js';
export const IconBell = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 18V19C9 20.6569 10.3431 22 12 22C13.6569 22 15 20.6569 15 19V18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M6 12V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V12C19.6569 12 21 13.3431 21 15V18H3V15C3 13.3431 4.34315 12 6 12Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconBell.js.map